export default __webpack_public_path__ + "static/media/ro.856cba92.jpg";